/**
 * This is used to differentiate category pages, could be used for SearchCatNavBannersRequest and layout related proto
 * for now we want to differentiate new brand page and featured brand page
 */ export var PageType = /*#__PURE__*/ function(PageType) {
    PageType["PAGE_TYPE_UNKNOWN"] = "PAGE_TYPE_UNKNOWN";
    PageType["EXPLORE_PAGE"] = "EXPLORE_PAGE";
    PageType["DISCOVER_PAGE"] = "DISCOVER_PAGE";
    return PageType;
}({});
